exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".show-qr-code__qrcode img{margin:auto}", ""]);

// exports
